module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-end-fill-a18f313b.svg";